// Styles
import '../scss/main.scss';

// Scripts
import { offer } from '@shop/frontend/dist/desktop/index';

$(document).ready(function () {
  offer.getState(function (data) {
    if (data.query.cmp === 'false') {
      $('.cmp-hide').hide();
      $('.cmp-show').show();
      $('body').addClass('cmp-clear');
    }
    $('.pricee').html('$' + data.products[0].price);

    const countries = ['CO', 'CR', 'GT', 'MX', 'NI', 'PA', 'PR', 'UY', 'VE'];
    const defaultIsoCode = 'CL';
    const iso_code = offer.getCountryIsoCode();
    const isoCodeLower = iso_code.toLowerCase();

    if (countries.includes(iso_code)) {
      iso(
        iso_code,
        `/static/common/shared/country-flags/flag-${isoCodeLower}.svg`,
        `/static/common/shared/made-for-${isoCodeLower}.svg`
      );
    } else {
      iso(
        defaultIsoCode,
        `/static/common/shared/country-flags/flag-${defaultIsoCode.toLowerCase()}.svg`,
        `/static/common/shared/made-for-${defaultIsoCode.toLowerCase()}.svg`
      );
    }
    function iso(text, flag, lbl) {
      $('.country-iso').html(text);
      $('.flag-iso').attr('src', flag);
      $('.label-iso').attr('src', lbl);
    }
  });

  let stickyOffset = $('#header').offset().top;
  $(window).scroll(function () {
    let sticky = $('#header'),
      scroll = $(window).scrollTop();
    if (scroll >= stickyOffset) sticky.addClass('fixed');
    else sticky.removeClass('fixed');
  });
});
